import { ApprovalType, ApprovalTypeDto, BaseQueryParams, IResponsePaginate, WithMetadata } from '@/types';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApprovalTypeService {
  BASEURL = `${environment.api.paramsUrl}/type_agrement`;
  httpClient = inject(HttpClient);

  getAll(params?: BaseQueryParams): Observable<IResponsePaginate<ApprovalType>> {
    return this.httpClient.get<IResponsePaginate<ApprovalType>>(`${this.BASEURL}`, { params: params as HttpParams });
  }

  create(approvalType: ApprovalTypeDto): Observable<WithMetadata<ApprovalType>> {
    return this.httpClient.post<WithMetadata<ApprovalType>>(`${this.BASEURL}`, approvalType);
  }

  update(id: number, approvalType: ApprovalTypeDto): Observable<WithMetadata<ApprovalType>> {
    return this.httpClient.put<WithMetadata<ApprovalType>>(`${this.BASEURL}/${id}`, approvalType);
  }

  delete(id: number): Observable<WithMetadata<ApprovalType>> {
    return this.httpClient.delete<WithMetadata<ApprovalType>>(`${this.BASEURL}/${id}`);
  }

  getOne(id: number): Observable<WithMetadata<ApprovalType>> {
    return this.httpClient.get<WithMetadata<ApprovalType>>(`${this.BASEURL}/${id}`);
  }
}
